import React, { useState } from "react";
import { useInitiateApplicationFeeMutation } from "../api/applicationFeeApi";
import { useLogoutMutation } from "../api/authApi"; // Added this

const PayApplicationFee: React.FC = () => {
  const [initiate, { isLoading }] = useInitiateApplicationFeeMutation();
  const [logout, { isLoading: isLoggingOut }] = useLogoutMutation(); // Added this
  const [error, setError] = useState<string | null>(null);

  const handleLogout = async () => {
    try {
      await logout().unwrap();
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  const handlePayment = async () => {
    setError(null);
    try {
      const res = await initiate().unwrap();

      console.log(res, "Application Fee Payment Init");

      if (!res?.merchant_reg_id || !res?.merch_trans_id) {
        setError("Invalid payment response");
        return;
      }

      // Create OnePay POST form
      const form = document.createElement("form");
      form.method = "POST";
      form.id = "OnePay_form";
      form.name = "OnePay_form";
      form.action = res.payment_url || "https://vuvaa.com/ONEPAY/mod/live/main";

      const fields = {
        merchant_reg_id: res.merchant_reg_id,
        amt_paid: res.amt_paid,
        merch_trans_id: res.merch_trans_id,
        client_phone: res.client_phone,
        product_desc: res.product_desc,
        client_email: res.client_email,
        client_name: res.client_name,
      };

      Object.entries(fields).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = String(value ?? "");
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (err: any) {
      setError(
        err?.data?.message || err?.message || "Failed to initiate payment"
      );
    }
  };

  return (
    <div className="fixed inset-0 min-h-screen w-full flex overflow-hidden bg-[#0f172a] text-slate-200">
      {/* BACKGROUND DECORATION */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-500/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-blue-500/10 blur-[120px] rounded-full" />

      <div className="flex-1 flex items-center justify-center p-6 relative z-10">
        <div className="w-full max-w-[420px]">
          <div className="bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 p-8 md:p-10 text-center">
            <img
              src="/niqs-logo.png"
              alt="NIQS Logo"
              className="h-16 mx-auto mb-6 invert"
            />

            <h2 className="text-2xl font-semibold text-white mb-3">
              Application Fee
            </h2>

            <p className="text-sm text-slate-400 mb-6">
              You must pay your application fee to proceed with your
              registration.
            </p>

            {error && (
              <div className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-3 mb-4">
                {error}
              </div>
            )}

            <div className="space-y-3">
              <button
                onClick={handlePayment}
                disabled={isLoading || isLoggingOut}
                className="w-full py-3.5 text-sm font-semibold bg-indigo-600 text-white rounded-xl hover:bg-indigo-500 active:scale-[0.98] disabled:opacity-50 transition-all shadow-lg shadow-indigo-600/20"
              >
                {isLoading ? "Redirecting..." : "Pay Application Fee"}
              </button>

              <button
                onClick={handleLogout}
                disabled={isLoggingOut || isLoading}
                className="w-full py-3 text-sm font-medium text-slate-400 hover:text-white hover:bg-white/5 rounded-xl transition-all border border-transparent hover:border-white/10"
              >
                {isLoggingOut ? "Logging out..." : "Logout & Exit"}
              </button>
            </div>
          </div>

          <p className="text-center mt-6 text-xs text-slate-500">
            Secure Payment Gateway &copy; {new Date().getFullYear()} NIQS
          </p>
        </div>
      </div>
    </div>
  );
};

export default PayApplicationFee;
